import type { BasicProductData } from 'components/layout/modals/compatible-combinations-browser-modal';
import {
  combinationSlotValues,
  DUCTED_SWAP_SLOTS
} from 'utils/ducted-component-swap';
import { DuctedSwapSlot } from 'utils/ducted-component-swap-types';

export type DuctedSlotRow = {
  slot: DuctedSwapSlot;
  slotLabel: string;
  modelText: string;
  product: BasicProductData | undefined;
};

const SLOT_CAPTIONS: Record<DuctedSwapSlot, string> = {
  outdoor: 'Outdoor',
  indoor: 'Indoor',
  blower: 'Blower'
};

export const ductedSlotRows = (
  combination: Record<string, unknown>,
  productData: Record<string, BasicProductData>
): DuctedSlotRow[] => {
  const values = combinationSlotValues(combination);
  return DUCTED_SWAP_SLOTS.flatMap((slot) => {
    const value = values[slot];
    if (value.key === '') return [];
    return [
      {
        slot,
        slotLabel: SLOT_CAPTIONS[slot],
        modelText: `${value.manufacturer} ${value.modelNumber}`,
        product: productData[`${value.manufacturer}|${value.modelNumber}`] as
          | BasicProductData
          | undefined
      }
    ];
  });
};
